import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from "@reduxjs/toolkit/query/react";


export const searchApiService = createApi({
  reducerPath: 'searchApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${baseURL}` }), // Base URL for your API
  endpoints: (builder) => ({
    searchProducts: builder.query({
      query: ({
        searchTerm,
        page,
        rowsPerPage,
        sortBy,
        minPrice,
        maxPrice,
        category,
        rating,
        subcategory,
        brand
      }) => {
        // Create an object with the query parameters
        const queryParams = {
          searchTerm,
          page,
          rowsPerPage,
          sortBy,
          minPrice,
          maxPrice,
          category,
          rating,
          subcategory,
          brand,
        };

        // Filter out undefined parameters
        const filteredParams = Object.fromEntries(
          Object.entries(queryParams).filter(([_, value]) => value !== undefined)
        );

        // Convert the filtered parameters to a query string
        const searchParams = new URLSearchParams(filteredParams).toString();

        return `/search/get?${searchParams}`; // Adjust endpoint as needed
      },
    }),
  }),
});


// Export the auto-generated hook for the search query
export const { useSearchProductsQuery } = searchApiService;
